import React from 'react';
import { Button, ModalWindow } from 'ui-toolkit';
import '../../scss/_RefiDetailsModal.scss';
import { IRefiDiscount } from '../../ui-toolkit/orders/interfaces/IRefiDiscount';

interface IRefiDetailsModalProps {
  onClose: () => void;
  refiDiscount: IRefiDiscount;
  refiConditionForState?: string | null;
}

const mapAppliedEligibilityToTitle = {
  ConditionallyEligibleByState: 'Refinance Discount Applied',
  NotConditionallyEligibleByState: 'Not Eligible for Refinance Discount',
  EligibleByState: 'Refinance Discount Automatically Applied',
  EligibleByBulkQualifiedLender: 'Bulk Refinance Rates Applied',
};

export default class RefiDetailsModal extends React.PureComponent<IRefiDetailsModalProps> {
  public render() {
    const { onClose, refiDiscount, refiConditionForState } = this.props;
    const titleKey =
      (refiDiscount.eligibility === 'ConditionallyEligibleByState' && !refiDiscount.applied ? 'Not' : '') +
      refiDiscount.eligibility;
    return (
      <ModalWindow className="refi-details-modal" uitype={'medium'} onClose={onClose}>
        <div className="refi-details-modal__content">
          <h3>{mapAppliedEligibilityToTitle[titleKey]}</h3>
          {refiDiscount.eligibility === 'ConditionallyEligibleByState' && refiDiscount.applied ? (
            <>
              <p>
                Discounted refinance rates are available in some states. There may be conditions to meet before they can
                be applied, however, where available these are applicable for all orders regardless of lender.
              </p>
              <p>
                This order has <strong>{refiConditionForState || ''}</strong>.
              </p>
            </>
          ) : null}
          {refiDiscount.eligibility === 'ConditionallyEligibleByState' && !refiDiscount.applied ? (
            <p>
              This order does not have <strong>{refiConditionForState || ''}</strong>.
            </p>
          ) : null}
          {refiDiscount.eligibility === 'EligibleByBulkQualifiedLender' ? (
            <p>
              Bulk refinance rates are available in some states, and only apply for lenders who have centralized order
              processing and meet the required order volumes per month. When we set up a lender in Pinecone we indicate
              if they qualify for bulk rates.
            </p>
          ) : null}
          {refiDiscount.eligibility === 'EligibleByState' ? (
            <p>
              Discounted refinance rates are available in some states. There may be conditions to meet before they can
              be applied, however, where available these are applicable for all orders regardless of lender.
            </p>
          ) : null}
          <Button intent="secondary" isInline onClick={onClose}>
            Close
          </Button>
        </div>
      </ModalWindow>
    );
  }
}
